import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      users: [],
      reference: null
    }
  },
  getters: {
    users (state) {
      return state.users
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state, payload) {
      state.users = payload
    },
    add (state, payload) {
      state.users.push(payload)
    },
    update (state, payload) {
      const index = state.users.findIndex(user => user.key === payload.key)
      if (index !== -1) {
        Vue.set(state.users, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.users.findIndex(user => user.key === payload.key)
      if (index !== -1) {
        state.users.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('users')
        var reference = dbRef.where('chatsShare', '==', true).onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            var data = JSON.parse(JSON.stringify(change.doc.data()))
            if (boot && change.type === 'added') {
              temp.push(data)
            } else if (change.type === 'added') {
              commit('add', data)
            } else if (change.type === 'modified') {
              commit('update', data)
            } else if (change.type === 'removed') {
              commit('remove', data)
            }
          })
          if (boot) {
            boot = false
            commit('init', temp)
          }
          resolve()
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['publicUsers/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    }
  }
}
